import { render, staticRenderFns } from "@/modules/Ticket/templates/tickets-dashboard.html?vue&type=template&id=24779e9a&scoped=true&"
import script from "@/modules/Ticket/scripts/tickets-dashboard.ts?vue&type=script&lang=js&"
export * from "@/modules/Ticket/scripts/tickets-dashboard.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Ticket/styles/tickets-dashboard.scss?vue&type=style&index=0&id=24779e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24779e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VImg,VSkeletonLoader,VTooltip})
